import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  obterMensagensPorPessoa,
  obterMensagensPorRL,
  quantidadeMensagensNaoLidasPorPessoa,
  quantidadeMensagensNaoLidasPorRL,
} from '../../api/mensagemAPI';
import { RootState } from '../../app/store';
import { authLogout } from '../../auth/authSlice';
import * as mensagens from '../../common/Mensagens';
import { perfilUpdated } from '../Perfil/perfilSlice';

export interface CaixaMensagemState {
  caixaMensagens: any[];
  quantidadeMensagensNaoLidas: number;
  mensagem: string;
  tipoMensagem: string;
  ativarMensagem: boolean;
  lastApiCallTime: any;
}

const initialState: CaixaMensagemState = {
  caixaMensagens: [],
  quantidadeMensagensNaoLidas: 0,
  mensagem: '',
  tipoMensagem: '',
  ativarMensagem: false,
  lastApiCallTime: null
};

export const getCaixaMensagens = createAsyncThunk(
  'caixaMensagem/getMensagens',
  async (idPessoa: any) => {
    return obterMensagensPorPessoa(idPessoa, true);
  }
);

export const getCaixaMensagensRL = createAsyncThunk(
  'caixaMensagem/getMensagensRL',
  async (idPessoa: any) => {
    return obterMensagensPorRL(idPessoa, true);
  }
);

export const getCaixaMensagensIdPositiva = createAsyncThunk(
  'caixaMensagem/getMensagensIdPositiva',
  async (idPessoa: any) => {
    return obterMensagensPorPessoa(idPessoa, false);
  }
);

export const getQuantidadeMensagensNaoLidas = createAsyncThunk(
  'caixaMensagem/getQuantidadeMensagensNaoLidas',
  async (idPessoa: any) => {
    return quantidadeMensagensNaoLidasPorPessoa(idPessoa, true);
  }
);

export const getQuantidadeMensagensNaoLidasRL = createAsyncThunk(
  'caixaMensagem/getQuantidadeMensagensNaoLidasRL',
  async (idPessoa: any) => {
    return quantidadeMensagensNaoLidasPorRL(idPessoa, true);
  }
);

export const getQuantidadeMensagensNaoLidasIdPositiva = createAsyncThunk(
  'caixaMensagem/getQuantidadeMensagensNaoLidasIdPositiva',
  async (idPessoa: any) => {
    return quantidadeMensagensNaoLidasPorPessoa(idPessoa, false);
  }
);

export const caixaMensagemSlice = createSlice({
  name: 'caixaMensagemSlice',
  initialState,
  reducers: {
    limpar: (state) => {
      state.caixaMensagens = initialState.caixaMensagens;
    },
    limparLastApiCallTime: (state) => {
      state.lastApiCallTime = initialState.lastApiCallTime;
    },
    ativarMensagem: (state, action) => {
      state.ativarMensagem = action.payload;
    },
    alterarMensagem: (state, action) => {
      state.mensagem = action.payload;
    },
    setLastApiCallTime: (state, action) => {
      state.lastApiCallTime = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCaixaMensagens.fulfilled, (state, action) => {
        state.caixaMensagens = action.payload;
        state.ativarMensagem = false;
        if (!state.caixaMensagens || state.caixaMensagens.length === 0) {
          state.tipoMensagem = 'warning';
          state.mensagem = mensagens.MSG_CAIXA_MENSAGENS_VAZIA;
          state.ativarMensagem = true;
        }
      })
      .addCase(getCaixaMensagensRL.fulfilled, (state, action) => {
        state.caixaMensagens = action.payload;
        state.ativarMensagem = false;
        if (!state.caixaMensagens || state.caixaMensagens.length === 0) {
          state.tipoMensagem = 'warning';
          state.mensagem = mensagens.MSG_CAIXA_MENSAGENS_VAZIA;
          state.ativarMensagem = true;
        }
      })
      .addCase(getCaixaMensagensIdPositiva.fulfilled, (state, action) => {
        state.caixaMensagens = action.payload;
        state.ativarMensagem = false;
        if (!state.caixaMensagens || state.caixaMensagens.length === 0) {
          state.tipoMensagem = 'warning';
          state.mensagem = mensagens.MSG_CAIXA_MENSAGENS_VAZIA;
          state.ativarMensagem = true;
        }
      })
      .addCase(getQuantidadeMensagensNaoLidas.fulfilled, (state, action) => {
        state.quantidadeMensagensNaoLidas = action.payload;
      })
      .addCase(getQuantidadeMensagensNaoLidasRL.fulfilled, (state, action) => {
        state.quantidadeMensagensNaoLidas = action.payload;
      })
      .addCase(getQuantidadeMensagensNaoLidasIdPositiva.fulfilled, (state, action) => {
        state.quantidadeMensagensNaoLidas = action.payload;
      })
      .addCase(authLogout.fulfilled, (state) => {
        // Ao realizar logout, resetar lastApiCallTime
        state.lastApiCallTime = initialState.lastApiCallTime;
      })
      .addCase(perfilUpdated, (state) => {
        // Ao mudar perfil, resetar lastApiCallTime
        state.lastApiCallTime = initialState.lastApiCallTime;
      });
  },
});

export const { limpar, limparLastApiCallTime, ativarMensagem, alterarMensagem, setLastApiCallTime } = caixaMensagemSlice.actions;

export const selectCaixaMensagens = (state: RootState) => state.caixaMensagem.caixaMensagens;
export const selectQuantidadeMensagensNaoLidas = (state: RootState) => state.caixaMensagem.quantidadeMensagensNaoLidas;
export const selectLastApiCallTime = (state: RootState) => state.caixaMensagem.lastApiCallTime;

export const selectState = (state: RootState) => state.caixaMensagem;

export default caixaMensagemSlice.reducer;
